export default "__VITE_ASSET__Cx5jO4ye__"